import React from 'react';
import styled from 'styled-components';

import SimpleButton from '../../Buttons/SimpleButton';
import Card from '../../Card/Card';
import {primaryColor} from '../../constants/colors';
import {
  mediaMinDesktopLarge,
  mediaMinTablet,
} from '../../constants/customMedia';
import {fsM, fsS} from '../../constants/typography';

const SelfServiceFlowPanelContainer = styled(Card)`
  flex-direction: column;
  padding: 20px 30px;

  @media ${mediaMinTablet} {
    padding: 30px 40px;
  }
`;

const Title = styled.h2`
  font-weight: bold;
  text-align: center;
  color: ${primaryColor};
  margin: 0;
  font-size: ${fsS}px;
  line-height: 1.71;
  padding-bottom: 16px;

  @media ${mediaMinDesktopLarge} {
    font-size: ${fsM}px;
    padding-bottom: 20px;
    line-height: 1.5;
  }
`;

const GreenButton = styled(SimpleButton)`
  display: flex;
  width: calc(100% - 60px);
  margin: auto;
  text-align: center;
  background-color: #63e8a5;
  color: ${primaryColor};
`;

export const SelfServiceFlowPanel: React.FC<{
  title: string;
  cta: string;
}> = ({title, cta}) => {
  return (
    <SelfServiceFlowPanelContainer>
      <Title>{title}</Title>
      <GreenButton
        data-testid="HelpCenterSSFPanelButton"
        disableShadow
        href="/h/ssf/0"
      >
        {cta}
      </GreenButton>
    </SelfServiceFlowPanelContainer>
  );
};
